import "./PlatformCapabilities.css";

const PlatformCapabilities = () => {
  return (
    <section className="platform-capabilities">
      <div className="platform-capabilities__header">
        <span className="platform-capabilities__eyebrow">
          <span className="platform-capabilities__dot"></span>
          Platform Capabilities
        </span>

        <h2>Clarity at every step of execution</h2>

        <p>
          Manage complex campaigns with precision, transparency, and a unified
          workflow that keeps every stakeholder aligned.
        </p>
        <div className="platform-capabilities__stats">
  <div className="platform-stat">
    <strong>4×</strong>
    <span>Faster approval</span>
  </div>

  <div className="platform-stat">
    <strong>68%</strong>
    <span>Less manual work</span>
  </div>

  <div className="platform-stat">
    <strong>∞</strong>
    <span>Brand workspaces</span>
  </div>
</div>
        
      </div>

      <div className="platform-capabilities__grid">
        {/* Large Card */}
        <div className="capability-card capability-card--large">
          <div className="capability-card__icon">♧</div>

          <h3>Audit Trail</h3>

          <p>
            Track every approval and deliverable change with a complete history
            of all campaign activity.
          </p>
        </div>

        <div className="capability-card capability-card--large">
          <div className="capability-card__icon">▤</div>

          <h3>Contract Automation</h3>

          <p>
            Generate and manage contracts automatically based on approved
            briefs and partner terms.
          </p>
        </div>

        {/* Small Cards */}
        <div className="capability-card">
          <div className="capability-card__icon">⌁</div>

          <h3>Live Delivery Status</h3>

          <p>
            Monitor campaign delivery in real-time with live status updates
            across all active executions.
          </p>
        </div>

        <div className="capability-card">
          <div className="capability-card__icon">▦</div>

          <h3>Unified Campaign View</h3>

          <p>
            Every campaign type in one cockpit, giving you a complete view of
            performance and execution.
          </p>
        </div>

        <div className="capability-card">
          <div className="capability-card__icon">▣</div>

          <h3>Multi-brand Asset Library</h3>

          <p>
            Manage assets across all brands with version control and centralized
            access for teams.
          </p>
        </div>

        <div className="capability-card">
          <div className="capability-card__icon">▭</div>

          <h3>Unified Payments</h3>

          <p>
            One payment engine across all partners, streamlining commercial
            terms and vendor payouts.
          </p>
        </div>
      </div>
    </section>
  );
};

export default PlatformCapabilities;